(function ($, window) {
    "use strict";
    DSV.ui = {
        //this is used to display track and trace overlay
        checkForTrackNumber: function (str) {
            // This function checks if a given string contains chunks of 5 characters with numbers or letters compined with a '-'.
            // ex: MA1DK-8CL72
            // If not, it checks if string contains a 4 numbers and then 7 digits
            // ex: ECMU1234567
            // If not, it finally checks if string contains 5-16 digits combined
            // ex: 1234567890123456
            // @returns eather one of the above and false if non of them are found.

            var matchQuery = str.match(/(^|\s)([a-z0-9]{5}\-[a-z0-9]{5})($|\s)/i) || str.match(/(^|\s)([A-Z]{4}[0-9]{7})($|\s)/i) || str.match(/(^|\s)([0-9]{3,16})($|\s)/);

            return matchQuery ? matchQuery[0] : false;
        },

        /***
         stockQuotes Object:
         ---------------
         Loads the stocks quotes regarding DSV and displays it.

         @Properties:
         ------------
         item =    The container for the stockquote text.


         @Methods:
         ---------
         get() =        Loads the NasDaq stockquote script via ajax, and calls update at successfull load.

         update() =    Udates the stockquote text, with the loaded data from the NasDaq script.
         ***/
        stockQuotes: {
            item: null,

            get: function () {

                var stq = this,
                url = "/layouts/Handlers/StockQuote.ashx";

                $.ajax({
                    type: "GET",
                    url: url,
                    dataType: "json",
                    contentType: 'application/json',
                    success: function (response){
                        stq.update(response);
                    },
                    error: function (xhr, status) {
                        console.log("Error status: " + status);
                    }
                });
            },

            update: function (data) {
                if (!this.item) {
                    this.item = $("#stockQuote");
                }

                var price = Number(data.lastTrade),
                    change = "" + data.changeNumber;

                // Format with 2 decimals
                if (String(price).split(".").length < 2 || String(price).split(".")[1].length <= 2 ){
                    price = price.toFixed(2);
                }

                // If the change isn't negative, add a + to the number
                if (change.indexOf("-") < 0) {
                    change = "+" + change;
                }

                // Update the text
                this.item.text(price + " / " + change);
            }
        },
        enableDataLinks: function() {
            DSV.DOM.document.on("click", "[data-link]", function(event) {
                event.stopPropagation();
                event.preventDefault();
                event.returnValue = false;

                var url = $(this).attr("data-link");

                window.open(url, "newwin");

            });
        },
        accordionHandler: {

            DOM: {
                modules: "",
                width: window.innerWidth,
            },

            throttleCloseAllAccordions: DSV.tools.throttle(function(){
                //resize event was triggered on scroll on mobile devices because of menubar and window height change
                //to prevent accordions to close in this case, we added this width change condition
                //ref: https://stackoverflow.com/questions/40437015/window-resize-executes-when-scrolling-on-mobile-devices
                if(DSV.ui.accordionHandler.DOM.width !== window.innerWidth) {
                    DSV.ui.accordionHandler.DOM.width = window.innerWidth;
                    DSV.ui.accordionHandler.closeAllAccordions();
                }
            }, 100),

            closeAllAccordions: function() {
                this.DOM.modules.find(".accordion__body").each(function () {
                    var $this = $(this),
                        height = $this.height();

                    TweenLite.to($this, .3, {marginTop:-height});
                });
            },

            scrollToActiveAccordion: function(accordionBody, el) {
                if (el.hasClass('accordion__radio')) {
                    //if accordionBody is outside of viewport, then scroll window to make is visible
                    if(!DSV.tools.isInViewport(accordionBody)) {
                        const offsetY = Math.round(el.offset().top);
                        const headerHeight = document.querySelector('.header').offsetHeight;
                        const scrollTargetPos = offsetY - headerHeight - 68;
                        TweenLite.to(window, 1, {scrollTo:scrollTargetPos, ease: Power2.easeOut});
                    }
                }
            },

            bindEvents: function() {
                this.DOM.modules.find(".accordion__reset").change(function(e) {
                    DSV.ui.accordionHandler.closeAllAccordions();
                });

                this.DOM.modules.find(".accordion__radio").change(function(e) {
                    const $this = $(this);
                    const accordionBody = this.parentElement.querySelector('.accordion__body');
                    DSV.ui.accordionHandler.closeAllAccordions();
                    TweenLite.to(accordionBody, .3, {marginTop:0, ease: Power3.easeInOut, onComplete: DSV.ui.accordionHandler.scrollToActiveAccordion, onCompleteParams: [accordionBody, $this]});
                })
            },

            init: function(modules){
                this.DOM.modules = modules;
                this.DOM.width = window.innerWidth;

                if(!this.DOM.modules.hasClass('accordion--initialized')) {
                    this.DOM.modules.addClass('accordion--initialized');
                    DSV.ui.accordionHandler.closeAllAccordions();
                    DSV.ui.accordionHandler.bindEvents();
                    DSV.DOM.window.on("resize", DSV.ui.accordionHandler.throttleCloseAllAccordions);
                }
            }
        }
    }; // DSV.ui
})(jQuery, window);